import styled from 'styled-components';
import SystemUpdateAltIcon from '@material-ui/icons/SystemUpdateAlt';
import { getSpacing, size } from 'stylesheet';

export const ActionIcon = styled(SystemUpdateAltIcon)`
  color: white;
`;

export const ActionButton = styled.button`
  background: none;
  border: 0;
  cursor: pointer;
  display: none;
  margin: 0 0 0 ${getSpacing(5)};
  padding: ${getSpacing(1)};

  &:hover {
    opacity: 0.75;
  }

  &:disabled {
    opacity: 0.5;
  }

  @media (min-width: ${size.tablet}) {
    display: block;
  }
`;

export const DownloadButton = styled.a`
  display: none;
`;
